import { useEffect, useState } from "react";
import { api, type StatusRegistrationTarget } from "../api";
import { Empty, Loading, ModalFrame } from "./ui";

export function StatusRegistrationModal({ taskId, onClose, onChanged }: { taskId: string; onClose: () => void; onChanged: (message: string) => void }) {
  const [targets, setTargets] = useState<StatusRegistrationTarget[] | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    void api.statusRegistrationTargets(taskId).then(value => { if (active) setTargets(value); })
      .catch(e => { if (active) setError(e instanceof Error ? e.message : "등록 가능한 칼럼을 불러오지 못했습니다."); });
    return () => { active = false; };
  }, [taskId]);
  return <ModalFrame compact eyebrow="업무 공유" title="현황판에 등록" onClose={() => { if (!busy) onClose(); }}><div className="modal-form">
    <p>게시 담당으로 배정된 팀의 칼럼을 선택하세요. 원본 업무의 공개·비공개 권한은 유지됩니다.</p>
    {error && <p role="alert" className="global-error">{error}</p>}
    {!targets && !error && <Loading label="등록 가능한 칼럼을 불러오는 중" />}
    {targets?.length === 0 && <Empty title="등록 가능한 칼럼이 없습니다" copy="이 업무 소속 팀을 게시 담당으로 지정하고, 직접 등록이 가능한 표시 방식을 선택해 주세요. 초안·발신 승인 대기 업무는 등록할 수 없습니다." />}
    <div className="status-register-results">{targets?.map(target => <button type="button" key={`${target.dashboardId}:${target.widgetId}`} disabled={busy} onClick={async () => {
      setBusy(true); setError("");
      try {
        await api.registerStatusTask(target.dashboardId, target.widgetId, taskId, target.registered);
        setTargets(current => current?.map(item => item === target ? { ...item, registered: !item.registered } : item) || []);
        onChanged(target.registered ? "직접 등록을 해제했습니다. 자동 표시 조건에 맞으면 계속 표시됩니다." : "현황판에 업무를 등록했습니다.");
      } catch (e) { setError(e instanceof Error ? e.message : "등록을 처리하지 못했습니다."); } finally { setBusy(false); }
    }}><span><b>{target.dashboardName}</b><small>{target.widgetTitle}</small></span><span>{target.registered ? "등록됨 · 해제" : "등록"}</span></button>)}</div>
  </div></ModalFrame>;
}
